import * as React from "react";
const SvgFiBrandsInvision = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-invision_svg__a)">
      <path
        fill="#151A2D"
        d="M24 2.176A2.176 2.176 0 0 0 21.824 0H2.176A2.176 2.176 0 0 0 0 2.176v19.649C0 23.026.974 24 2.176 24h19.649A2.175 2.175 0 0 0 24 21.824zM7.997 4.685c.798 0 1.466.625 1.466 1.444 0 .82-.668 1.445-1.466 1.445a1.45 1.45 0 0 1-1.466-1.445c0-.819.668-1.444 1.466-1.444m9.809 13.82c-1.488 0-2.199-.883-2.199-2.091 0-.345.043-.711.151-1.078l.712-2.544a2.6 2.6 0 0 0 .108-.776c0-.819-.496-1.315-1.294-1.315-1.013 0-1.682.727-2.027 2.129l-1.38 5.535H9.462l.433-1.739c-.71 1.166-1.695 1.888-2.911 1.888-1.466 0-2.156-.845-2.156-2.117 0-.323.043-.719.129-1.085l1.1-4.492H4.354l.517-1.909h4.096L7.35 15.324c-.108.41-.151.75-.151.987 0 .41.202.53.518.601.192.043 1.724.013 2.559-1.841l1.062-4.253H9.613l.517-1.909h3.687l-.474 2.167c.647-1.208 1.94-2.355 3.212-2.355 1.358 0 2.48.968 2.48 2.822 0 .474-.065.99-.237 1.572l-.69 2.479c-.065.26-.108.475-.108.669 0 .431.173.647.496.647s.733-.238 1.207-1.552l.949.366c-.561 1.962-1.574 2.781-2.846 2.781"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-invision_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsInvision;
